"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlToSquizNode = void 0;
const remirror_1 = require("remirror");
const remirrorNodeToSquizNode_1 = require("../remirrorNodeToSquizNode/remirrorNodeToSquizNode");
const core_1 = require("@remirror/core");
const Extensions_1 = require("../../../Extensions/Extensions");
const htmlToSquizNode = ({ content }) => {
    const extensions = (0, Extensions_1.createExtensions)({
        matrix: {
            matrixDomain: 'unsupported',
        },
        resolveNodeToUrl: () => {
            throw new Error('Resolving Url is not supported.');
        },
    });
    const manager = core_1.RemirrorManager.create(extensions);
    return (0, remirrorNodeToSquizNode_1.remirrorNodeToSquizNode)((0, remirror_1.htmlToProsemirrorNode)({
        content,
        schema: manager.schema,
    }));
};
exports.htmlToSquizNode = htmlToSquizNode;
